<template>
    <div class="col-12" v-if="createPermission == true">
        <div class="card">
            <b-button v-b-toggle.create-form variant="primary" class="mb-3">
                {{ $t('label.createX', [$t('module.productLabel')]) }}
                <i class="mdi" :class="isCreateCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'"
                    style="margin-left: 5px;"></i>
            </b-button>
            <b-collapse id="create-form" v-model="isCreateCollapsed">
                <div class="card-body">
                    <div class="col">
                        <div class="card">
                            <div class="card-body">
                                <form @submit.prevent="requestCreate" v-if="createPermission == true">
                                    <ImageUploader :showImageTop="true" :buttonText="'Choose Endorsed Label'"
                                        ref="coverUploader" :multiple="false" @images-removed="removePhoto"
                                        @images-changed="updatePhoto" />

                                    <div class="row">
                                        <div class="col-lg-6">
                                            <b-form-group id="displayImages" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.productImage')" label-for="displayImages">
                                                <ImageUploader :showImageTop="false" :multiple="true"
                                                    ref="galleryUploader" @images-changed="updateImages" />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group id="productName" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('module.product')" label-for="productName">
                                                <b-form-input id="productName" v-model.trim="createForm.productName"
                                                    readonly></b-form-input>
                                            </b-form-group>
                                        </div>

                                        <!-- <div class="col-md-6">
                                <b-form-group id="name" label-cols-sm="4" label-cols-lg="4"
                                    :label="$t('label.name')" label-for="name">
                                    <b-form-input id="name" v-model.trim="createForm.name" :class="{
                                        'is-invalid': submitted && !$v.createForm.name.required
                                    }"></b-form-input>
                                    <div v-if="submitted && !$v.createForm.name.required" class="invalid-feedback"
                                        style="display: block;">
                                        <span>{{ $t("message.requiredX", [$t("label.name")]) }}</span>
                                    </div>
                                </b-form-group>
                            </div> -->

                                        <div class="col-md-6">
                                            <b-form-group id="packageSize" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.packageSize')" label-for="packageSize">
                                                <b-form-input id="packageSize" v-model.trim="createForm.packageSize"
                                                    :class="{
                                                        'is-invalid': submitted && !$v.createForm.packageSize.required
                                                    }"></b-form-input>
                                                <div v-if="submitted && !$v.createForm.packageSize.required"
                                                    class="invalid-feedback" style="display: block;">
                                                    <span>{{ $t("message.requiredX", [$t("label.packageSize")])
                                                        }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="date" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.date')" label-for="date">
                                                <date-picker v-model="createForm.date" type="date" format="YYYY-MM-DD"
                                                    value-type="format" placeholder="Select date"></date-picker>
                                                <div v-if="submitted && !$v.createForm.date.required"
                                                    class="invalid-feedback" style="display: block;">
                                                    <span>{{ $t("message.requiredX", [$t("label.date")]) }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group id="packagingMaterial" label-cols-sm="4" label-cols-lg="4"
                                                :label="$t('label.packagingMaterial')" label-for="packagingMaterial">
                                                <b-form-input id="packagingMaterial"
                                                    v-model.trim="createForm.packagingMaterial" :class="{
                                                        'is-invalid': submitted && !$v.createForm.packagingMaterial.required
                                                    }"></b-form-input>
                                                <div v-if="submitted && !$v.createForm.packagingMaterial.required"
                                                    class="invalid-feedback" style="display: block;">
                                                    <span>{{ $t("message.requiredX",
                                                        [$t("label.packagingMaterial")])
                                                        }}</span>
                                                </div>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="mt-4 text-center" style="float: right">
                                        <button class="btn btn-primary w-md waves-effect waves-light"
                                            style="margin-right: 10px" type="submit" :disabled="status.create">
                                            {{ $t("label.createX", [$t("module.productLabel")]) }}
                                        </button>
                                    </div>
                                </form>
                                <div style="text-align: center;" v-else>
                                    {{ $t('message.noPermissionMessage') }}
                                </div>
                            </div>
                        </div>
                        <!-- end card -->
                    </div>
                </div>
            </b-collapse>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { PRODUCT_LABEL_MODULE } from '@/state/modules/productLabel'
import ImageUploader from '@/components/upload-image';
import DatePicker from 'vue2-datepicker';
import { productLabelMethods } from "@/state/helpers";
import { required } from "vuelidate/lib/validators";

export default {
    props: {
        createPermission: {
            type: Boolean,
            required: true
        },
        triggerSearchName: {
            type: String,
            default: null
        },
        triggerSearch: {
            type: String,
            default: null,
        },
        searchCriteria: {
            type: Object,
            required: false
        }
    },
    components: { ImageUploader, DatePicker },
    watch: {
        triggerSearchName: {
            immediate: true,
            handler(newVal) {
                this.createForm.productName = newVal;
            }
        },
        triggerSearch: {
            immediate: true,
            handler(newValue) {
                this.createForm.productID = newValue;
            }
        }
    },
    validations: {
        createForm: {
            date: { required },
            packageSize: { required },
            packagingMaterial: { required }
        },
    },
    data() {
        return {
            submitted: false,
            isCreateCollapsed: false,
            createForm: {
                name: "",
                productID: this.triggerSearch,
                productName: this.triggerSearchName,
                packageSize: "",
                file: "",
                date: "",
                image: "",
                packagingMaterial: "",
            },
        }
    },
    methods: {
        ...productLabelMethods,
        removePhoto() {
            this.createForm.image = null;
        },
        updatePhoto(image) {
            this.createForm.image = image[0].file;
        },
        updateImages(images) {
            this.createForm.files = [];

            for (var i = 0; i < images.length; i++) {
                this.createForm.files.push(images[i].file)
            }
        },
        resetCreateForm() {
            this.createForm = {
                name: "",
                productID: this.triggerSearch,
                productName: this.triggerSearchName,
                packageSize: "",
                file: "",
                date: "",
                image: "",
                packagingMaterial: "",
                files: []
            };
            this.submitted = false;
            this.$v.$reset();
            this.$refs.coverUploader?.clear?.();
            this.$refs.galleryUploader?.clear?.();
        },
        async requestCreate() {
            this.submitted = true;

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                if (this.createPermission == true) {
                    let data = {
                        name: this.createForm.name,
                        packageSize: this.createForm.packageSize,
                        files: this.createForm.files,
                        date: this.createForm.date,
                        packagingMaterial: this.createForm.packagingMaterial,
                        image: this.createForm.image,
                        productID: this.createForm.productID
                    };
                    var result = await this.createProductLabelFaster({ data, filter: this.searchCriteria });

                    if (result == true) {
                        this.resetCreateForm();
                    }
                }
            }
        },
    },
    computed: {
        ...mapState(PRODUCT_LABEL_MODULE, ['status']),
    }
}
</script>
